import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const MessageReactionsDualViewPage = lazy(
  () => import("../../pages/MessageReactionsDualViewPage")
);
const NUXBusinessTypePage = lazy(
  () => import("../../pages/NUXBusinessTypePage")
);
const ProductCategoryPickerPage = lazy(
  () => import("../../pages/ProductCategoryPickerPage")
);
const StarterCollectionsPage = lazy(
  () => import("../../pages/StarterCollectionsPage")
);

export function CristiWallaceRoutes() {
  return (
    <Switch>
      <Route path="/cw/nux/business-type" component={NUXBusinessTypePage} />
      <Route
        path="/cw/starter-collections"
        component={StarterCollectionsPage}
      />
      <Route
        path="/cw/product-category-picker"
        component={ProductCategoryPickerPage}
      />
      <Route
        path="/cw/message-reactions-dual-view"
        component={MessageReactionsDualViewPage}
      />
    </Switch>
  );
}

export const slug = "cw";
